import { create } from 'zustand';
import { Profile } from '../types/profile';
import {
  ProfileSnapshot,
  profileToSnapshot,
  loadProfileSnapshot,
  saveProfileSnapshot,
  clearProfileSnapshot,
} from '../services/profileSnapshot';

interface ProfileState {
  activeProfile: Profile | null;
  /**
   * Minimum profile fields persisted to localStorage for synchronous
   * hydration at boot. Public-path UI (TopBar, HomePage, ListingDetailsPage)
   * reads this via `useDisplayProfile` so the logged-in shell paints on
   * first render — no flash of Sign-In button before the avatar lands.
   * Written through `setActiveProfile` on every login / profile update;
   * cleared by `setActiveProfile(null)` on logout / profile switch.
   */
  displaySnapshot: ProfileSnapshot | null;
  setActiveProfile: (profile: Profile | null) => void;
}

const initialSnapshot = loadProfileSnapshot();

export const useProfileStore = create<ProfileState>((set) => ({
  activeProfile: null,
  displaySnapshot: initialSnapshot,
  setActiveProfile: (activeProfile) => {
    if (activeProfile) {
      const snap = profileToSnapshot(activeProfile);
      saveProfileSnapshot(snap);
      set({ activeProfile, displaySnapshot: snap });
    } else {
      clearProfileSnapshot();
      set({ activeProfile: null, displaySnapshot: null });
    }
  },
}));
